import { GraphSchema } from '@camelot/server';

export interface MailSyncConfiguration {
  id: string;
  name: string;
  clientTenantId: string;
  clientId: string;
  clientSecret: string;
}

export interface MailSyncConfigurationCreationPayload {
  name: string;
  clientTenantId: string;
  clientId: string;
  clientSecret: string;
}

export interface MailSyncConfigurationModifierPayload {
  id: string;
  name: string;
  clientTenantId: string;
  clientId: string;
  clientSecret: string;
  updatedFields: string[];
}

export const mailSyncConfigurationProps = new GraphSchema<MailSyncConfiguration>([
  'id',
  'name',
  'clientTenantId',
  'clientId',
  'clientSecret',
]);
